import { Navigate, RouteObject } from "react-router-dom";
import { Suspense } from "react";
import routePaths from "./routePaths";

const errorElement = () => {
    return <div>error </div>;
};

const CommonRoutes: RouteObject[] = [
    {
        path: routePaths.DEFAULT.path,
        element: <Suspense fallback={<></>}><Navigate to={routePaths.HOME.path} /></Suspense>,
        caseSensitive: false,
        id: routePaths.DEFAULT.id,
        errorElement: errorElement(),
    }
];

export default CommonRoutes;